module.exports = __webpack_public_path__ + "static/media/multivariatetesting.494f9baf.pdf";